import CartProducts from '../CartProducts';
import FreeProductInCart from '../FreeProductInCart';
import OfferSection from '../OfferSection';

export default function CartProductsCover(props) {
  const {
    cartProducts,
    setSnackBarMessage,
    changeProductHandler,
    showCartFiller,
    offerListFetcher,
    paymentPage,
    isB2G1SkuAdded,
  } = props;
  return (
    <>
      {cartProducts?.map((element, index) => {
        return element?.offer_id ? (
          <OfferSection
            key={'cartproductcover' + index}
            cartProducts={element}
            setSnackBarMessage={setSnackBarMessage}
            offerId={element?.offer_id}
            changeProductHandler={changeProductHandler}
            showCartFiller={showCartFiller}
            offerListFetcher={offerListFetcher}
            paymentPage={paymentPage}
            isB2G1SkuAdded={isB2G1SkuAdded}
          />
        ) : (
          <>
            {element.hasOwnProperty('saleOfferedProduct') &&
            !showCartFiller &&
            !element?.isConsultationProduct ? (
              <FreeProductInCart
                product={item}
                changeProductHandler={changeProductHandler}
                key={'cartproductcoverproduct' + index}
              />
            ) : (
              <CartProducts
                key={'cartproductcoverproduct' + index}
                product={element}
                setSnackBarMessage={setSnackBarMessage}
                offerListFetcher={offerListFetcher}
                paymentPage={paymentPage}
                isConsultationProduct={element.isConsultationProduct}
              />
            )}
          </>
        );
      })}
    </>
  );
}
